import { render, staticRenderFns } from "./CardExpert.vue?vue&type=template&id=10ad4646&scoped=true"
import script from "./CardExpert.vue?vue&type=script&lang=js"
export * from "./CardExpert.vue?vue&type=script&lang=js"
import style0 from "./CardExpert.vue?vue&type=style&index=0&id=10ad4646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad4646",
  null
  
)

export default component.exports